import { render, staticRenderFns } from "./ExpandTransition.vue?vue&type=template&id=50e87614&scoped=true&"
var script = {}
function injectStyles (context) {
  
  var style0 = require("./ExpandTransition.vue?vue&type=style&index=0&id=50e87614&scoped=true&lang=css&")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "50e87614",
  null
  ,true
)

export default component.exports